import { SvgIcon, SvgIconProps } from "@mui/material";

export default ({ ...props }: SvgIconProps) => (
  <SvgIcon height="24px" viewBox="0 0 100 100" width="24px" {...props}>
    <rect
      width="54"
      height="85"
      x="23"
      y="7"
      rx="3"
      ry="3"
      fill="#f00"
      strokeWidth="0.5"
      stroke="#000"
    />
  </SvgIcon>
);
